import React from 'react';
import styles from './Insurance.module.sass';
import theme from '../../App.module.sass';
import formStyles from '../../components/UserForms/UserForm.module.sass';
import RadioGroup from "../../components/ui/RadioGroup/RadioGroup";
import Button from '../../components/ui/Button/Button';
import PurchaseDetailsCard from "../../components/PurchaseDetailsCard/PurchaseDetailsCard";
import api from "../../utils/api";
import AppContext from "../../contexts/appContext";
import gaTags from './../../utils/ga-tags';


import insuranceIcon from '../../assets/svgs/seguro.svg';

class Insurance extends React.Component {

  state = {
    insurance: this.context.insurance ? 'S' : 'N',
    percentage: null
  };

  static contextType = AppContext;

  advanceClickHandler = () => {
    this.context.setContext({
      ...this.context,
      insurance: this.state.insurance === 'S'
    });

    this.props.history.push({
      pathname: "/pagamento"
    });
  };

  insuranceChangeHandler = (value) => {
    if (value === 'S' && this.state.percentage == null) {
      const requestParams = {
        codigoVenda: this.context.selectedOffer.identificacao.codigoVenda,
        codigoGrupo: this.context.selectedOffer.identificacao.codigo,
        codigoSubProduto: parseInt(this.context.product.id),
        codigoTaxa: this.context.selectedOffer.dados.plano.identificacao.codigoTaxa,
        codigoPlano: this.context.selectedOffer.dados.plano.identificacao.codigo,
        codigoProduto: this.context.selectedOffer.codigoProduto,
        cpfCnpj: this.context.document
      };

      api.get(api.endpoints.INSURANCE, null, requestParams).then((result) => {
        this.setState({insurance: value, percentage: result.data.percentual})
      });
    } else {
      this.setState({insurance: value})
    }
  };

  render() {

    const insuranceName = this.state.insurance === "S" ? "Sim" : "Não"
    const gaTypeName = `${gaTags.typeFlow2.concat("3-")}&${insuranceName}&-Prestamista`


    return (
      <div className={styles.Insurance}>
        <div className={styles.content}>
          <section className={formStyles.sectionForm}>
            <article className={styles.textInsurance}>
              <h2 className={styles.title}>
                Em caso de invalidez por acidente ou morte,
                suas parcelas restantes do Consórcio podem ser quitadas, basta contratar o Seguro Prestamista.
              </h2>
              <p className={styles.marginTop}>Evite deixar esse gasto para quem você ama.</p>
              <p className={styles.marginBottom}>Esse seguro é opcional.</p>
              <img alt="Seguro Prestamista" className={styles.imageInsurance} src={insuranceIcon} />
            </article>
          </section>
          <section className={formStyles.sectionForm}>
            <p className={styles.titleRadio}>Deseja Adquirir?</p>
            <RadioGroup
              options={["S", "N"].map(el => ({value: el, text: el === 'S' ? 'Sim' : 'Não'}))}
              value={this.state.insurance}
              onChanged={this.insuranceChangeHandler}
            />
            {
              (this.state.percentage && this.state.insurance === 'S') &&
              <span className={styles.info}>
                Acréscimo de {this.state.percentage}% a partir da 2ª parcela
              </span>
            }

          </section>
          <footer className={theme.footerForm}>
            <span
              onClick={() =>
                this.props.history.push({
                  pathname: '/dados-cliente'
                })
              }
              className={theme.backLabel} role="link">
              <i className="icon icon-seta-esquerda"/>
              Voltar
            </span>

            <Button
              selected
              onClick={this.advanceClickHandler}
              data-gacategory={gaTags.categoryFlow}
              data-gatype={gaTypeName}
              data-gafunc={`${gaTypeName}-Continuar`}>
              Continuar
            </Button>
          </footer>
        </div>
        <div className={styles.card}>
          <PurchaseDetailsCard offer={this.context}/>
        </div>
      </div>
    );
  }
}

export default Insurance;
